module.exports = __webpack_public_path__ + "media/assets/logo-b-a5097522a67581881d916826e082e938.svg";